import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { FirebaseService } from 'src/app/service/firebase.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalMainComponent } from '../../modals/modal-main/modal-main.component';
import { GlobalService } from '../../services/global.service';
import { TranslationPipe } from '../pipes/translation.pipe';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy, AfterViewInit {


  dialogRef: any;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  groupsArray: any = [];
  deviceArray: any = [];
  arrayModulesToReturn: any = [];
  activesModules: any = {};
  moduleName: any = {
    'kiosk': { name: 'webPage', priority: 2 },
    'data': { name: 'data', priority: 5 },
    'quiz': { name: 'quiz', priority: 3 },
    'lottery': { name: 'lottery', priority: 4 },
    'media': { name: 'mediaContent', priority: 1 },
    'selfie': { name: "selfie", priority: 6 },
    'mapcontent': { name: "mapcontent", priority: 7 }
  }

  modulePath: any = {
    'kiosk': '/kiosk',
    'data': '/datas',
    'quiz': '/quiz',
    'lottery': '/lottery',
    'media': '/media',
    'selfie': '/selfie',
    'mapcontent': '/mapcontent'
  }
  window: any;

  constructor(
    private breakpointObserver: BreakpointObserver,
    public sharedService: SharedService,
    public firebaseService: FirebaseService,
    public dialog: MatDialog,
    public global: GlobalService,
    public translation: TranslationPipe,
    private _ref: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.sharedService.firebaseInit();


    this.window = window;

    this.sharedService.observerSelectedDevice.subscribe(d => {

      let tmp = [];
      this.arrayModulesToReturn = [];
      let listModules = this.sharedService.selectedDevice.data.modules;

      console.log(listModules)
      for (var module in listModules) {
        if (listModules.hasOwnProperty(module)) {
          if (listModules[module]) {
            //    console.log(this.moduleName, module, this.moduleName[module])
            if (this.moduleName[module])
              tmp.push({ name: this.moduleName[module].name, path: this.modulePath[module], priority: this.moduleName[module].priority })

          }
        }
      }




      this.arrayModulesToReturn = tmp.sort(function (a, b) {
        if (a.priority > b.priority)
          return 1
        else
          return -1;

      })


      if (this.sharedService.selectedDevice?.data.modules.mediaLimiter) {

       // alert("HIDE LOTTERY")
        this.arrayModulesToReturn = this.arrayModulesToReturn.filter(v => v.name != 'lottery')
      }

    })




  }

  checkAvailalbleKiosk() {
    let array = ['XTxtXs2wqXgVSR9JCgOXh3evRFW2', 'KvsRXRgGbRYBgHW63rxMwXAdfs42']


 //   console.log("STATS ACCESS", array.includes(this.firebaseService.user.uid), this.firebaseService.user.uid)
    if (array.includes(this.firebaseService.user.uid))
      return true;
    else
      return false;
  }

  ngAfterViewInit() {
    this.firebaseService.globalActiveModule.subscribe(d => {
      //console.log(this.sharedService.devicesArray);

      console.log(this.firebaseService.user)
      console.log(this.sharedService.devicesArray, this.sharedService.devicesArray.length);

      if (this.firebaseService.user.role != 'admin' && this.sharedService.devicesArray && this.sharedService.devicesArray.length == 1) {
        console.log(this.sharedService.devicesArray, this.sharedService.devicesArray.length);
        this.sharedService.setActiveBorne(this.sharedService.devicesArray[0])
      }

      this.activesModules = d;
      // console.log("ACTIVE MODULE:", this.activesModules)
    })


    this.sharedService.groupArraySub$.subscribe(d => {
      console.log("GROUPS ARRAY", d)
      if (this.firebaseService.user.role != 'admin' && this.sharedService.devicesArray && this.sharedService.devicesArray.length == 1) {
        console.log(this.sharedService.devicesArray, this.sharedService.devicesArray.length);
        this.sharedService.setActiveBorne(this.sharedService.devicesArray[0])
      }
    })

    this.sharedService.devicesArraySub$.subscribe(d => {
      console.log("DEVICE ARRAY", d)
      if (this.firebaseService.user.role != 'admin' && this.sharedService.devicesArray && this.sharedService.devicesArray.length == 1) {
        console.log(this.sharedService.devicesArray, this.sharedService.devicesArray.length);
        this.sharedService.setActiveBorne(this.sharedService.devicesArray[0])
      }
    })
  }

  sortModules(tab) {
  }

  ngOnDestroy() {
    this.sharedService.observerSelectedDevice.unsubscribe();
  }

  openDialog() {
    this.dialogRef = this.dialog.open(ModalMainComponent, {
      width: '300px',
      height: '300px',
      data:
      {
        title: this.translation.transform('deco'),
        subtitle: `${this.translation.transform('loggedInAs')} ${this.firebaseService.user.displayName}`,
        buttonLabel: this.translation.transform('logout'),
        buttonColor: 'warn'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.sharedService.selectedDevice = null;
        this.firebaseService.logout();

      }

    });
  }


}
